module.exports = __webpack_public_path__ + "img/responses.9241028d.png";